import Tween from "tween.ts";
import Animation from "./Animation";
import RedArrow from "../entities/howtoplay/firstPart/RedArrow";


export default class HTPRedArrowAnimation extends Animation {
  constructor(arrow: RedArrow, y: number, onComp: () => void) {
    super();
    new Tween.Tween(arrow)
      .to({ y }, 1000)
      .easing(Tween.Easing.Bounce.Out)
      .onComplete(() => onComp())
      .start()
  }
}